import { ACTION } from './building_type_actions';

const initialState = {
  buildingTypes: {},
  orderedIds: [],
  loading: false,
  errorMessage: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${ACTION.LIST}_PENDING`:
      return {
        ...state,
        loading: true,
        errorMessage: null,
      };
    case `${ACTION.LIST}_FULFILLED`:
      return {
        ...state,
        buildingTypes: action.payload.reduce((types, type) => ({...types, [type.id]: type}), {}),
        orderedIds: action.payload.map(province => province.id),
        loading: false,
      };
    case `${ACTION.LIST}_REJECTED`:
      return {
        ...state,
        loading: false,
        errorMessage: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/building_type/building_type_reducers.js